import cn from 'classnames';
import styles from './ActionButtons.module.css';
import { FunctionComponent } from 'react';
import {Image} from 'react-bootstrap';
import { ASSESTS } from '../../../constant/assest';
import CustomButton, { ButtonType } from '../../common/CustomButton/CustomButton';

export interface IActionButtonsProps {
  editBtnImage?: string;
  editBtnClick?: () => void;
  viewBtnImage?: string;
  viewBtnClick: () => void;
  showForwarBtn?: boolean;
  forWardBtnImage?: string;
  forWardBtnClick?: () => void;
  className?: string;
}

const ActionButtons: FunctionComponent<IActionButtonsProps> = ({ viewBtnImage, viewBtnClick, showForwarBtn, forWardBtnImage, forWardBtnClick, className}) => {

  
  return (
    <div className={cn(styles.actionBtns, className)}>
        {/* <CustomButton
            onClick={editBtnClick}
            btnType={ButtonType.NOSTYLE}
            className={styles.actionBtn}
        >
            <Image src={editBtnImage? editBtnImage : ASSESTS.EDITICON} alt={'Edit'} />
        </CustomButton> */}
        <CustomButton
            onClick={viewBtnClick}
            btnType={ButtonType.NOSTYLE}
            className={styles.actionBtn}
        >
            <Image src={viewBtnImage? viewBtnImage : ASSESTS.VIEWICON} alt={'View'} />
        </CustomButton>
        {showForwarBtn &&
        <CustomButton
            onClick={forWardBtnClick}
            btnType={ButtonType.NOSTYLE}
            className={styles.actionBtn}
        >
            <Image src={forWardBtnImage ? forWardBtnImage : ASSESTS.VIEWICON} alt={'ForWard'} />
        </CustomButton>
        }
    </div>
  );
};

export default ActionButtons;
